// @section: header
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Brand";
import { NAV_ITEMS, CONTACT_URL } from "@/lib/site";

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function Header() {
  const [open, setOpen] = useState(false);

  const go = (id: string) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex h-16 items-center justify-between">
          <button onClick={() => go("top")} aria-label="linect ホーム">
            <Logo />
          </button>

          {/* @section: header-nav-desktop */}
          <nav className="hidden md:flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => go(item.id)}
                className="text-sm font-medium text-secondary-foreground hover:text-accent transition-colors"
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="hidden md:block">
            <a
              href={CONTACT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-[4px] bg-accent px-5 py-2.5 text-sm font-semibold text-accent-foreground hover:opacity-90 transition-opacity"
            >
              お問い合わせ
            </a>
          </div>

          {/* @section: header-mobile-toggle */}
          <button
            className="md:hidden grid place-items-center h-10 w-10 rounded-[4px] border border-border text-primary"
            onClick={() => setOpen((v) => !v)}
            aria-label="メニュー"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* @section: header-mobile-menu */}
      {open && (
        <div className="md:hidden border-t border-border bg-background">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => go(item.id)}
                className="text-left py-3 px-2 text-sm font-medium text-secondary-foreground hover:text-accent border-b border-border last:border-0"
              >
                {item.label}
              </button>
            ))}
            <a
              href={CONTACT_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center rounded-[4px] bg-accent px-5 py-3 text-sm font-semibold text-accent-foreground"
            >
              お問い合わせ
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
